export default function getBlobMIMEType(base64Content) {
	const signatures = {
		JVBERi0: 'application/pdf',
		R0lGODdh: 'image/gif',
		R0lGODlh: 'image/gif',
		iVBORw0KGgo: 'image/png',
	};

	let MIMEType = '';

	for (var s in signatures) {
		if (base64Content.indexOf(s) === 0) {
			MIMEType = signatures[s];
			break;
		}
	}

	return MIMEType;
}
